// extracted by mini-css-extract-plugin
export var searchHeader = "_9d-0";
export var searchHeaderDark = "_9d-1";